export default __webpack_public_path__ + "static/media/oshw.7f01a6f5.svg";